import React, { useState, useEffect,useCallback,useRef } from "react";
import DataGrid, {
  Column,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Scrolling,
  LoadPanel,
  SearchPanel,
  Pager,
  Paging,
  Button,
} from "devextreme-react/data-grid";
import Guid from "devextreme/core/guid";
import { createStore } from "devextreme-aspnet-data-nojquery";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import "../../modal.css";
import Grid from "@material-ui/core/Grid";
import { api_path } from "../../shared";
import SearchIcon from "@mui/icons-material/Search";
function ServiceContractGridModal(props) {

  const [modeSize, setModeSize] = useState('widget');
  const pageSizes = [25, 50, 100];
  const [show, setShow] = useState(false);
  const seenPopUp = localStorage.getItem('seenPopUp');
  const handleShow = () => setShow(true);
  const [getOldCarrier, setOldCarrier] = useState("");
  const [GET_CARRIER, SET_CARRIER] = useState(props.CARRIER_CODE);
  const countRef = useRef(GET_CARRIER);
  const handleClose = () => {
    // setting key "seenPopUp" with value true into localStorage
    //localStorage.setItem("seenPopUp", 1);
    // setting state to false to not display pop-up
    setShow(false)
  };

  // the useEffect to trigger on first render and check if in the localStorage we already have data about user seen and closed the pop-up
  useEffect(() => {
   
  }, []);
  const [getTotalCount, setTotalCount] = useState();
  useEffect(() => {
    getServicesContract()
  },[props.CARRIER_CODE]);
  const getServicesContract = useCallback(async () => {
    axios
      .get(api_path + `/MS_SERVICE_CONTRACT.php?CARRIER=${props.CARRIER_CODE}`)
      .then((response) => {
        if (response.data.status == "201") {
          setShow(false);
        } else {
          if(props.IS_OPEN==1)
          setShow(true);
         
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props.CARRIER_CODE]); // set dependency array of callback properly
  const url =
    api_path + "/MS_SERVICE_CONTRACT.php?CARRIER=" + props.CARRIER_CODE;
  //const url = api_path + "/MS_SERVICE_CONTRACT.php?CARGO=" + props.CARGO_TYPE + "&CARRIER=" + props.CARRIER;
  //const url = api_path + "/MS_SERVICE_CONTRACT.php";
  const dataSource = createStore({
    key: "SERVICE_CONTRACT_ID",
    loadUrl: `${url}`,
  });

  const onEditButtonClick = React.useCallback((e) => {
    const key = new Guid().toString();
    const dataRow = e.row && e.row.data;
    props.updateServiceData(
      props.CARRIER_ITEM_ID,
      dataRow.CARRIER_CODE,
      dataRow.SERVICE_CONTRACT_NO,
      dataRow.BULLET_CODE,
      dataRow.SCAC,
      dataRow.CONDITION,
      dataRow.VALIDITY,
      dataRow.SPECIAL_FLAG,
      props.CARRIER_INDEX
    );
    handleClose();
  }, []);
  const cellPrepared = (e) => {
    setTotalCount(e.component.totalCount());
    if (e.rowType === "data") {
      if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG === "2") {
        e.cellElement.style.cssText = "color: red;font-weight:normal;";
      }else if (e.column.dataField === "CONDITION" && e.data.SPECIAL_FLAG === "3") {
        e.cellElement.style.cssText = "color: red;font-weight:normal;";
      // } else if (e.column.dataField === "VALID" && e.data.VALID === "Invalid") {
      //   e.cellElement.style.cssText = "color: #ff6f4a;font-weight:bold;";
      }
    }
  };
  const numberFormat = (value) =>
    new Intl.NumberFormat("en-IN", {
    }).format(value);
  return (
    <>
                {/* {showButton && ( */}
      <SearchIcon
        onClick={handleShow}
        style={{
          marginRight: "0px",
          marginTop: "5px",
          cursor: "pointer",
        }}
      />
                {/* )} */}
      <Modal
        size="xl"
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        scrollable={true}
      >
        <Modal.Header closeButton>
          {(props.CARRIER_CODE &&
          <Modal.Title>SERVICE CONTRACT | CARRIER: {props.CARRIER_CODE}</Modal.Title>
        )}
        </Modal.Header>
        <Modal.Body>
          <Grid container>
            <br />
            {getTotalCount > 1 && (
              <div style={{ marginTop: 0, lineHeight: "25px" }}>
                <div>
                  {" "}
                  Found: {numberFormat(getTotalCount)} items&nbsp;
                </div>
              </div>
            )}
            <DataGrid
              onCellPrepared={cellPrepared}
              dataSource={dataSource}
              showBorders={true}
              columnAutoWidth={true}
              rowAlternationEnabled={false}
              allowColumnReordering={true}
              allowColumnResizing={true}
              columnResizingMode={modeSize}
              columnMinWidth={50}
              showScrollbar={true}
              keyExpr="SERVICE_CONTRACT_ID"
           
            >
              <Scrolling
                rowRenderingMode="virtual"
                showScrollbar="always"
                useNative="false"
                scrollByThumb="true"
              ></Scrolling>
              <FilterRow visible={true} />
              <FilterPanel visible={true} />
              <HeaderFilter visible={true} />
              <SearchPanel
                visible={true}
                width={240}
                placeholder="Full Text Search..."
              />
              <Column dataField="TRADE_LANE" caption="TRADE" width={80} />
              <Column dataField="CARRIER_CODE" caption="CARRIER" width={80} />
              {/* <Column dataField="CARGO_TYPE" caption="CARGO TYPE" width={100} /> */}
              <Column
                dataField="SERVICE_CONTRACT_NO"
                caption="SERVICE CONTRACT"
              />
              <Column dataField="BULLET_CODE" caption="BULLET" />
              <Column dataField="SCAC" visible={false}/>
              <Column dataField="CONDITION" caption="DESCRIPTION" />
              <Column dataField="VALIDITY" caption="VALIDITY" />
              <Column dataField="SPECIAL_FLAG" visible={false} />
              <Column type="buttons" width={50} fixed={true}>
                <Button icon="add" onClick={onEditButtonClick} hint="Add" />
              </Column>

              <LoadPanel enabled={true} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
              <Paging defaultPageSize={25} />
            </DataGrid>
          </Grid>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ServiceContractGridModal;
